import PropTypes from 'prop-types'
import React from 'react'
import { helpers, TableBodyCell, TableRow } from 'react-wot-bootstrap'

import BaseMembersTableItem from './BaseMembersTableItem'

class MembersTableItem extends BaseMembersTableItem {
    render() {
        const getValueType = (value) => {
            return value ? undefined : 'null'
        }

        const formattedValue = (value, roundDown = false) => {
            return helpers.thousands(value || 0, roundDown)
        }

        return (
            <TableRow
                isHoverable
                isActive={this.isRowActive()}
                needPlayHoverSound={this.needPlayHoverSound()}
                onClick={this.props.displayCheckbox ? this.onRowClick : null}
            >
                {this.renderTableCellCheckbox()}
                {this.renderTableCellRole()}
                {this.renderTableCellMember()}
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.personalRating)}
                    valueWidth="38px"
                    isValue
                >
                    { helpers.thousands(this.props.personalRating) }
                </TableBodyCell>
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.battlesCount)}
                    valueWidth="45"
                    isValue
                >
                    { formattedValue(this.props.battlesCount) }
                </TableBodyCell>
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.winsPercentage)}
                    valueWidth="48"
                    isValue
                >
                    { helpers.percent(this.props.winsPercentage || 0) }
                </TableBodyCell>
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.expPerBattle)}
                    valueWidth="31"
                    isValue
                >
                    { formattedValue(this.props.expPerBattle, true) }
                </TableBodyCell>
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.damagePerBattle)}
                    valueWidth="31"
                    isValue
                >
                    { formattedValue(this.props.damagePerBattle, true) }
                </TableBodyCell>
                <TableBodyCell
                    type="center"
                    valueType={getValueType(this.props.memberDaysInClan)}
                    valueWidth="31"
                    isValue
                >
                    { helpers.thousands(this.props.memberDaysInClan) }
                </TableBodyCell>
                {this.renderTableCellMemberStatus()}
            </TableRow>
        )
    }
}

MembersTableItem.propTypes = {
    ...MembersTableItem.propTypes,
    battlesCount: PropTypes.number,
    damagePerBattle: PropTypes.number,
    expPerBattle: PropTypes.number,
    winsPercentage: PropTypes.number,
    winsCount: PropTypes.number,
    personalRating: PropTypes.number,
    logoutAt: PropTypes.number,
}

export default MembersTableItem



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/StatisticsMembersTableItem.js